import { useNode } from 'react-pagebuilder/hooks/useNode'
import { defaultProps } from './index'
import VideoToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const VideoSettings = () => {
  const { props } = useNode((node) => ({
    customs: node.data.custom,
    props: node.data.props,
  }))

  return (
    <>
      <VideoToolbarSection defaultProps={defaultProps} props={props} initOpen />
      <LayoutToolbarSection defaultProps={defaultProps} />
    </>
  )
}
